import { useAuthActions, useAuthToken } from '@/store/auth';
import { useSiteStore } from '@/store/site';
import { cloudUrlParser } from '@/utils/aws-domain-util';
import { getResponseJwtHeader } from '@/utils/web';
import { fetchComposer } from '@nf/utils-common/compose-fetch';

export function useChangeEmail () {
	const apiDomain = useSiteStore((state) => state.apiDomain);
	const authToken = useAuthToken();
	const { updateAuthToken } = useAuthActions();
	async function saveEmail(currEMail: string, newEMail: string): Promise<boolean> {
		try {
			const formData = new URLSearchParams();
			formData.append('currEMail', currEMail);
			formData.append('newEMail', newEMail);
			const response = await fetchComposer.postWithBearer(
				cloudUrlParser(`${apiDomain.ctcdDomain}/setting/SaveEMail`),
				{
					body: formData.toString(),
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
						Accept: 'application/json',
					},
				}
			)(authToken);
			const data = await response.json();
			if (data?.Data?.Code === 0) {
				const responseJwtHeader = getResponseJwtHeader(response);
				responseJwtHeader && updateAuthToken(responseJwtHeader); 
				return true;
			} else if (data?.Data?.Code === 1) {
				throw new EmailError(data?.Data?.Message);
			} else if (data?.Data?.Code === 2) {
				throw new EmailTaken(data?.Data?.Message);
			} else {
				throw new Error();
			}
		} catch (e) {
			throw e
		}
	}
	
	return {
		saveEmail
	}
}

export class EmailError extends Error {};
export class EmailTaken extends Error {};